export default __webpack_public_path__ + "static/media/base.4ee01d7b.svg";